import {
  NavbarFloating,
  NavbarBackLink,
  NavbarButton,
  NavbarContainer,
  NavbarLink,
  NavbarLinksGroup,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const Navbar = {
  Floating: NavbarFloating,
  Container: NavbarContainer,
  LinksGroup: NavbarLinksGroup,
  Link: NavbarLink,
  BackLink: NavbarBackLink,
  Button: NavbarButton,
};
